import React, { useContext } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import TypeIconReturner from "../../../components/TypeIconReturner/TypeIconReturner";
import { Link } from "react-router-dom";
import AttachmentsDropdown from "../../../components/AttachmentsDropdown/AttachmentsDropdown";
import Avatar from "../../../components/Avatar/Avatar";
import StatusColorBall from "../StatusColorBall/StatusColorBall";
import ConfigIcon from "../../../components/VectorIcons/ConfigIcon";
import DragAreaIcon from "../../../components/VectorIcons/DragAreaIcon";
import AppContext from "../../../context/appContext";
import ActivityContext from "../../../context/activitiesContext";
import { removeDuplicateAttachments } from "../utils";

const ActivitiesUsers = (props) => {
  const { activity, handleEditActivity, bgColor, verifyFormat } = props;

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: `${activity.id}` });

  const style = {
    background: isDragging ? "#f2f2f2" : "#ffffff",
    transform: CSS.Transform.toString(transform),
    transition,
    touchAction: "none",
  };

  const dragIconStyle = {
    cursor: isDragging ? "grabbing" : "grab",
  };

  const appContext = useContext(AppContext);
  const activityContext = useContext(ActivityContext);
  const uniqueAttachments = removeDuplicateAttachments(activity.attachments);
  const isAddendum = (attachment) =>
    attachment?.attachmentType?.name === "Adendo";

  const authorsOrCreators = {
    "Obra Literária": "authors",
    Dramaturgia: "creators",
    Variedades: "creators",
  };

  return (
    <div className="activityItem" ref={setNodeRef} style={style}>
      <div className="activityCell activityTitle">
        <TypeIconReturner type={activity.contentType} responsiveIcon={true} />

        <div className="containerText">
          {activity.contentType === "Pesquisa" && (
            <span onClick={() => handleEditActivity(activity)}>
              {activity.contentTitle}
            </span>
          )}

          {activity.contentType !== "Pesquisa" && (
            <Link
              to={`/atividades/${
                activityContext.activitiesContentTypeNames[activity.contentType]
              }/${activityContext.remakeTypeEvaluations(
                activity.type.value
              )}/${activity.evaluationId}`}
            >
              <span>{activity.contentTitle}</span>
            </Link>
          )}

          {activity.contentType !== "Pesquisa" && (
            <div className="Author">
              {!!activity[authorsOrCreators[activity.contentType]]?.length &&
                activity[authorsOrCreators[activity.contentType]]?.map(
                  (creator, creatorIndex) => {
                    return (
                      <div
                        className="creator"
                        key={`${activity.id}-creator-${creatorIndex}`}
                      >
                        <span>{creator}</span>
                        {creatorIndex + 1 <
                          activity[authorsOrCreators[activity.contentType]]
                            .length && <span className="separator">|</span>}
                      </div>
                    );
                  }
                )}
            </div>
          )}
        </div>
      </div>

      <div className="activityCell activityAttachments">
        <span className="activityTypeName">{activity.type.value}</span>

        {!!uniqueAttachments.length && (
          <div className="attachmentsInfo">
            {verifyFormat(activity) && (
              <>
                <span className="file">
                  Cap {uniqueAttachments[0].chapterNumber}
                </span>
                <span className="fileBlock">
                  Bloco {uniqueAttachments[0].blockNumber}
                </span>
                <span className="fileVersion">
                  {uniqueAttachments[0].version}º Versão
                </span>
              </>
            )}

            {!verifyFormat(activity) && (
              <>
                <span className="file">
                  {!!uniqueAttachments[0].attachmentType &&
                    uniqueAttachments[0].attachmentType.name}
                </span>
                {!isAddendum(uniqueAttachments[0]) && (
                  <span className="fileVersion">{` - ${uniqueAttachments[0].version}º Versão`}</span>
                )}
              </>
            )}

            {uniqueAttachments.length > 1 && (
              <AttachmentsDropdown
                attachments={uniqueAttachments}
                format={activity.format}
              />
            )}
          </div>
        )}
      </div>

      <div className="activityCell activityAnalist">
        {!!activity.user ? (
          <>
            <Avatar bgColor={bgColor} letter={activity.user.name.slice(0, 1)} />
            <span>{activity.user.name}</span>
          </>
        ) : (
          `-`
        )}
      </div>

      <div className="activityCell activityStatus">
        <StatusColorBall status={activity.status.value} />
        {activity.status.value}
      </div>

      <div className="activityCell activityCreatedAt">
        {appContext.formatDate(appContext.convertDatePtBr(activity.receivedAt))}
      </div>

      <div className="activityCell activityConfig">
        <div
          className="configActivity"
          onClick={() => handleEditActivity(activity)}
        >
          <ConfigIcon />
        </div>
        {!!activity.user && (
          <div
            className="dragIcon"
            style={dragIconStyle}
            {...attributes}
            {...listeners}
          >
            <DragAreaIcon />
          </div>
        )}
      </div>
    </div>
  );
};

export default ActivitiesUsers;
